import { useState, useCallback } from 'react';

interface SnackbarState {
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'warning' | 'info';
}

export const useSnackbar = () => {
    const [snackbarState, setSnackbarState] = useState<SnackbarState>({
        open: false,
        message: '',
        severity: 'info'
    });

    const showSnackbar = useCallback((message: string, severity: 'success' | 'error' | 'warning' | 'info' = 'info') => {
        setSnackbarState({
            open: true,
            message,
            severity
        });
    }, []);

    const hideSnackbar = useCallback(() => {
        setSnackbarState(prev => ({ ...prev, open: false }));
    }, []);

    return {
        snackbarState,
        showSnackbar,
        hideSnackbar
    };
};